import "core-js/modules/es.object.assign.js";
var createBaseGAEvent = GA4_props => {
  //Setting the default event name
  if (!GA4_props.event || GA4_props.event !== "GAevent") GA4_props.event = "GAevent";
  return Object.assign({
    social: null,
    agency_id: null,
    agency_name: null,
    agency_place_id: null,
    agency_subscription_type: null,
    agency_franchise_id: null,
    agency_franchise_name: null,
    product_price: null,
    real_estate_id: null,
    //TODO: controllare che sia effettivamente utilizzato, parrebbe di no
    real_estate_contract_id: null,
    real_estate_place_id: null,
    real_estate_typology_name: null,
    agent_id: null,
    agent_email: null,
    user_name: null,
    user_email: null,
    user_phone: null,
    service: null,
    user_company_name: null,
    user_surname: null,
    user_id: null,
    real_estate_contract_type: null,
    real_estate_typology_id: null,
    auction_consultant_id: null,
    auction_consultant_name: null,
    auction_guardian_id: null,
    auction_guardian_name: null,
    auction_supervisor_id: null,
    auction_supervisor_name: null,
    valuation_type: null,
    valuation_purpose: null,
    view_type: null,
    switcho_banner_type: null
  }, GA4_props);
};
/**
 * Given the input payload, creates a valid GA4 event and pushes it to the dataLayer
 * */
var pushDataLayerEvent = payload => {
  //@ts-ignore
  window["dataLayer"].push(createBaseGAEvent(payload));
};
var sendShareGAEvent = payload => {
  pushDataLayerEvent( /* event_name can be just two values: share_real_estate or share_valuation */
  payload);
};
var sendSpecificRequestGAEvent = payload => {
  //Precondition: The specific request lead has ALWAYS the realEstateId
  pushDataLayerEvent(payload);
};
var sendAuctionConsultantRequestGAEvent = payload => {
  pushDataLayerEvent(payload);
};
var sendMortgageGAEvent = _ref => {
  var {
    event_location,
    event_name
  } = _ref;
  pushDataLayerEvent({
    event_name,
    event_location
  });
};
var sendMailAlertSaveGAEvent = payload => {
  pushDataLayerEvent(payload);
};
var sendGenericRequestLead = payload => {
  pushDataLayerEvent(payload);
};
var sendNewsletterSubscribeGAEvent = payload => {
  pushDataLayerEvent(payload);
};
var sendPhoneShowGAEvent = payload => {
  pushDataLayerEvent(payload);
};
var sendAuctionConsultantPhoneShowGAEvent = payload => {
  pushDataLayerEvent(payload);
};
var auctionGuardianShowPhone = payload => {
  pushDataLayerEvent(payload);
};
var auctionSupervisorShowPhone = payload => {
  pushDataLayerEvent(payload);
};
var sendPublicUserLoginGAEvent = payload => {
  pushDataLayerEvent(payload);
};
var sendNotificationOpenedGAEvent = payload => {
  pushDataLayerEvent(payload);
};
var sendSignUpGAEvent = payload => {
  pushDataLayerEvent(payload);
};
var sendErrorRequestGAEvent = payload => {
  var {
    event_location,
    event_name
  } = payload;
  pushDataLayerEvent({
    event_name,
    event_location,
    code_error: "request_already_made_409"
  });
};
var sendPremiumInfoGAEvent = payload => {
  pushDataLayerEvent(payload);
};
var sendValuationComplete = payload => {
  pushDataLayerEvent(payload);
};
var sendValuationLead = payload => {
  pushDataLayerEvent(payload);
};
var sendDownloadPDF = payload => {
  pushDataLayerEvent(payload);
};
var sendRequestModalInteractionGAEvent = payload => {
  pushDataLayerEvent(payload);
};
var sendRequestModalInteractionConsultantGAEvent = payload => {
  pushDataLayerEvent(payload);
};
var copyAVMwidgetGAEvent = payload => {
  pushDataLayerEvent(payload);
};
var copyTrendWidgetGAEvent = payload => {
  pushDataLayerEvent(payload);
};
var sendAVMwidgetRequest = payload => {
  pushDataLayerEvent(payload);
};
var sendPublishLocation = payload => {
  pushDataLayerEvent(payload);
};
var sendMrOpenFormGaEvent = payload => {
  pushDataLayerEvent(payload);
};
var sendMrFormInteractionGaEvent = payload => {
  pushDataLayerEvent(payload);
};
var sendMrLead = payload => {
  pushDataLayerEvent(payload);
};
var sendPvpForm = payload => {
  pushDataLayerEvent(payload);
};
var auctionConsultantRequestOpenForm = payload => {
  pushDataLayerEvent(payload);
};
var sendReListingViewGaEvent = payload => {
  pushDataLayerEvent(payload);
};
var sendAgencyListingViewGaEvent = payload => {
  pushDataLayerEvent(payload);
};
var sendSwitchoBannerAdGaEvent = payload => {
  pushDataLayerEvent(payload);
};
var sendHomePublishBannerEvent = payload => {
  pushDataLayerEvent(payload);
};
var sendPublishProLoginEvent = payload => {
  pushDataLayerEvent(payload);
};
var sendPublishTypeGaEvent = payload => {
  pushDataLayerEvent(payload);
};
var sendRealEstateDeleteConfirmEvent = payload => {
  pushDataLayerEvent(payload);
};
var sendRealEstatePublishStartEvent = payload => {
  pushDataLayerEvent(payload);
};
var sendRealEstateEditStartEvent = payload => {
  pushDataLayerEvent(payload);
};
var sendRealEstatePrivateStepsEvent = payload => {
  pushDataLayerEvent(payload);
};
var sendRealEstatePublishEndEvent = payload => {
  pushDataLayerEvent(payload);
};
var sendRealEstateEditEndEvent = payload => {
  pushDataLayerEvent(payload);
};
var sendPublishPartnerLinkEvent = payload => {
  pushDataLayerEvent(payload);
};
var sendTopAgencyModalOpenedEvent = payload => {
  pushDataLayerEvent(payload);
};
var sendTopAgencyWidgetCopiedEvent = payload => {
  pushDataLayerEvent(payload);
};
var GAEventHandler = {
  /* Share valuation event
  * Triggered from:
  * - step 3
  * */
  valuation_share: sendShareGAEvent,
  /*
  * Share real estate event
  * Triggered from:
  * - Gallery.vue     -> real_estate/show.jsp
  * - CardMap         -> real_estate/index.jsp
  * - Insertion.jsp   -> real_estate/[index|show].jsp, favorites.jsp, request.jsp, trend.jsp, step_3.jsp
  * */
  real_estate_share: sendShareGAEvent,
  /* Specific request event (triggered from: contactAgencyModal, contactAgencyBanner ) */
  specific_request_lead: sendSpecificRequestGAEvent,
  /* Triggered from contactAgencyModal */
  auction_consultant_lead: sendAuctionConsultantRequestGAEvent,
  /* Triggered from:
  * - ContactAgencySuccess (toggleMortgage accepted)  -> real_estate/index.jsp
  * - ServicesModal (service == MORTGAGE)             -> real_estate/show.jsp
  *  */
  mortgage: sendMortgageGAEvent,
  /* Enable save search event.
  * Triggered from:
  * - saveSearchModal -> real_estate/index.jsp, real_estate/show.jsp
  * - contactAgencySuccessModal (toggleSearch accepted) -> private/request.jsp. private/favourites.jsp, 404.jsp, real_estate/[index|show].jsp
  * - step_3 (purpose: BUY, contactDesired, isLogged)
  *  */
  mail_alert_save: sendMailAlertSaveGAEvent,
  /*
  * Generic request event
  * Triggered from: ContactAgencySuccess (toggleGeneric accepted)
  * */
  generic_request_lead: sendGenericRequestLead,
  /*
  * Get real estate news event
  * Triggered from: ContactAgencySuccess (toggleNews accepted)
  * */
  newsletter_subscribe: sendNewsletterSubscribeGAEvent,
  /*
  * Phone show event
  * Triggered from:
  * - ConsultantCard.vue      -> real_estate/show.jsp
  * - agency.jsp              -> real_estate/show.jsp
  * - agency_insertion.jsp    -> real_estate/index.jsp, agency/index.jsp
  * - top_agency_banner.jsp   -> real_estate/index.jsp
  * - consultant_cards.jsp    -> real_estate/index.jsp
  * - 404.jsp
  * - requests.jsp
  * - agency/show.jsp
  * - contactAgencyModal.vue  -> [real_estate|agency]/index.jsp, [real_estate|agency]/show.jsp, favourites.jsp, requests.jsp
  * - contactAgencyBanner.vue
  * Conditions:
  * - There must be a phone span element
  * - just one event per insertion/modal
  * - updatePhoneView must be successful
  * */
  phone_show: sendPhoneShowGAEvent,
  /*
  * User login event
  * Triggered from: LoginModal, useLoginProvider
  * Conditions:
  * - Successful login for one of these: regular login, sso login
  * */
  public_user_login: sendPublicUserLoginGAEvent,
  /*
  * Desktop or android mobile notification open event
  * Triggered when the user opens a foreground or background notification
  * */
  push_notification_opened: sendNotificationOpenedGAEvent,
  /*
  * User registered event
  * Triggered when the user perform a successful registration
  * */
  public_user_sign_up: sendSignUpGAEvent,
  /*
  * Premium - contact desired event
  * Triggered when the contact form is successful
  * */
  premium_info: sendPremiumInfoGAEvent,
  /*
  * Step 3 - valuation complete event
  * Triggered when there is a publicValuationCookie in the page which is set in the previous step
  * */
  valuation_complete: sendValuationComplete,
  /*
  * Step 3 - valuation lead event
  * Triggered when there is a publicValuationCookie in the page which is set in the previous step.
  * In case the user which performed the valuation is also an owner, we will add "isSelling" data
  * */
  valuation_lead: sendValuationLead,
  /*
  * Step 3 - valuation print
  * Triggered when the user click the print button
  * */
  valuation_pdf_download: sendDownloadPDF,
  /*
  * Specific request error event 409 (Conflict)
  * Triggered by: ContactAgencyBanner, ContactAgencyModal
  * */
  specific_request_error_409: sendErrorRequestGAEvent,
  /*
  * Specific request form interaction
  * Triggered by: ContactAgencyBanner, ContactAgencyModal
  * Conditions: one element of the form is interacted with or submit button click
  * */
  specific_request_interaction: sendRequestModalInteractionGAEvent,
  /*
  * Interaction of the field inside the modal
  * Triggered when one field of the form received an interaction from a user
  * Triggered by: ContactAgencyModal
  * Conditions: Contract type is auction
  * */
  auction_consultant_request_interaction: sendRequestModalInteractionConsultantGAEvent,
  /*
  * Valuation widget copied
  * Triggered when the user copies the widget in the page widgets_preview.jsp
  * */
  copy_avm_widget: copyAVMwidgetGAEvent,
  /*
  * trend widget copied
  * Triggered when the user copies the widget in the page widgets_preview.jsp
  * */
  copy_trend_widget: copyTrendWidgetGAEvent,
  /*
  * Full version widget request success event
  * Triggered when the request has been fulfilled without errors in widgets_preview.jsp
  * */
  send_avm_widget_request: sendAVMwidgetRequest,
  /*
  * Publish ads on wiki request success event
  * Triggered when the request has been fulfills without errors (home.jsp)
  * */
  send_publish_location: sendPublishLocation,
  /*
  * Market report example modal opened event
  * Triggered when the modal is opened
  * */
  mr_open_form: sendMrOpenFormGaEvent,
  /*
  * Market report example modal interacted event
  * Triggered when the form is interacted in market_report.jsp
  * */
  mr_form_interaction: sendMrFormInteractionGaEvent,
  /*
  * Market report example modal submitted event
  * Triggered when the form has been successfully submitted in market_report.jsp
  * */
  mr_lead: sendMrLead,
  send_form_to_pvp: sendPvpForm,
  /*
  * Contact Modal Consultant opened event
  * Triggered when the modal is opened
  * Triggered by: ContactAgencyModal
  * Conditions: Contract type is auction
  * */
  auction_consultant_request_open_form: auctionConsultantRequestOpenForm,
  auction_consultant_phone_show: sendAuctionConsultantPhoneShowGAEvent,
  re_listing_view: sendReListingViewGaEvent,
  agency_listing_view: sendAgencyListingViewGaEvent,
  auction_guardian_phone_show: auctionGuardianShowPhone,
  auction_supervisor_phone_show: auctionSupervisorShowPhone,
  switcho_banner_ad_view: sendSwitchoBannerAdGaEvent,
  switcho_banner_ad_click: sendSwitchoBannerAdGaEvent,
  /*
  * Publish / edit private - section
  * */
  home_publish_banner_click: sendHomePublishBannerEvent,
  publish_pro_login_click: sendPublishProLoginEvent,
  publish_cta_click: sendPublishTypeGaEvent,
  publish_real_estate_delete_confirm: sendRealEstateDeleteConfirmEvent,
  real_estate_publish_start: sendRealEstatePublishStartEvent,
  real_estate_edit_start: sendRealEstateEditStartEvent,
  /*
  * Check Steps reached into (publish or edit) private section
  * Triggered when the step is switched
  * Triggered by: PublishPrivateSteps
  * */
  real_estate_publish_steps: sendRealEstatePrivateStepsEvent,
  real_estate_edit_steps: sendRealEstatePrivateStepsEvent,
  real_estate_publish_end: sendRealEstatePublishEndEvent,
  real_estate_edit_end: sendRealEstateEditEndEvent,
  publish_partner_link_click: sendPublishPartnerLinkEvent,
  /*
  * Check actions related to the top agency widget
  * Triggered when the modal is opened or a link is copied in show.jsp
  * Triggered by: BadgeModal copy button
  */
  top_agency_widget_open_modal: sendTopAgencyModalOpenedEvent,
  top_agency_widget_copy_link: sendTopAgencyWidgetCopiedEvent
};
export function sendGAEvent(GAEvent, payload) {
  var handler = GAEventHandler[GAEvent];
  var _payload = payload ? Object.assign(Object.assign({}, payload), {
    event_name: GAEvent
  }) : {
    event_name: GAEvent
  };
  //@ts-ignore
  handler(_payload);
}